import { render } from "./informationCollection.vue?vue&type=template&id=6cff73ba&scoped=true"
import script from "./informationCollection.vue?vue&type=script&lang=js"
export * from "./informationCollection.vue?vue&type=script&lang=js"

import "./informationCollection.vue?vue&type=style&index=0&id=6cff73ba&lang=css"
import "./informationCollection.vue?vue&type=style&index=1&id=6cff73ba&scoped=true&lang=css"

import exportComponent from "D:\\myProgram\\cloud-storage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cff73ba"]])

export default __exports__